<form action="">
  <ui-input 
  variant="radio-inline" 
  name="selectedFilter"
  [(ngModel)]="selectedFilter"
  (ngModelChange)="onChange()">


    <ui-input-option [value]="'*'">
      <slot name="filterAllLabel"></slot>
    </ui-input-option>
    <ui-input-option [value]="'fixed'">
      <slot name="filterFixedPriceContractLabel"></slot>
    </ui-input-option>
    <ui-input-option [value]="'variable|spot'">
      <slot name="filterSpotPriceContractLabel"></slot>
    </ui-input-option>
  </ui-input>
</form>